<template>
  <div>
    <div class="reason" v-if="type == 1 && list.reason">
      未通过原因：{{ list.reason }}
    </div>
    <van-cell-group class="body kuang">
      <van-cell v-if="list.name" title="姓名" :value="list.name" />
      <van-cell
        v-if="list.sex"
        title="性别"
        :value="format(list.sex, 12)"
      />
      <van-cell
        v-if="list.birthday"
        title="出生年月"
        :value="format(list.birthday, 6)"
      />
      <van-cell v-if="list.phone" title="手机号" :value="list.phone" />
      <van-cell
        v-if="list.province"
        title="行政区域"
        :value="`${list.province || ''}${list.city || ''}${list.district || ''}`"
      />
      <van-cell
        v-if="list.zzmm"
        title="政治面貌"
        :value="format(list.zzmm, 21)"
      />
      <van-cell v-if="list.name" title="总辅导员级别" :value="list.fdyLevTxt" />
      <van-cell
        v-if="list.quFdyNum"
        title="本县（市、区、旗）所属乡镇（街道）总辅导员数量"
        :value="list.quFdyNum + '人'"
      />
      <van-cell
        v-if="list.isHljXjt"
        title="本级是否有红领巾巡讲团"
        :value="format(list.isHljXjt, 1)"
      />
      <van-cell
        v-if="list.hljXjtNum"
        title="本级红领巾巡讲团人数"
        :value="list.hljXjtNum + '人'"
      />
      <van-cell v-if="list.eduTxt && list.eduTxt !== '请选择'" title="全日制教育学历" :value="list.eduTxt" />
      <van-cell v-if="list.majorTxt && list.majorTxt !== '请选择'" title="所学专业大类" :value="list.majorTxt" />
      <van-cell v-if="list.collegeTxt && list.collegeTxt !== '请选择'" title="毕业院校" :value="list.collegeTxt" />
      <van-cell v-if="list.highestEduTxt && list.highestEduTxt !== '请选择'" title="最高教育学历" :value="list.highestEduTxt" />
      <van-cell v-if="list.highestMajorTxt && list.highestMajorTxt !== '请选择'" title="所学专业大类" :value="list.highestMajorTxt" />
      <van-cell v-if="list.highestCollegeTxt && list.highestCollegeTxt !== '请选择'" title="毕业院校" :value="list.highestCollegeTxt" />
      <van-cell v-if="list.highestEduXZTxt && list.highestEduXZTxt !== '请选择'" title="最高教育学历性质" :value="list.highestEduXZTxt" />
      <van-cell v-if="list.organizationTxt && list.organizationTxt !== '请选择'" title="本人编制所在单位" :value="list.organizationTxt" />
      <van-cell v-if="list.tuanJobTxt && list.tuanJobTxt !== '请选择'" title="团内职务" :value="list.tuanJobTxt" />
      <van-cell v-if="list.jobTypeTxt && list.jobTypeTxt !== '请选择'" title="本人编制类型" :value="list.jobTypeTxt" />
      <van-cell v-if="list.jobLevTxt && list.jobLevTxt !== '请选择'" title="行政（事业）级别" :value="list.jobLevTxt" />
      <van-cell v-if="list.teachSubjectNumTxt && list.teachSubjectNumTxt !== '请选择'" title="任教学科门数" :value="list.teachSubjectNumTxt" />
      <van-cell v-if="list.teachSubjectsTxtArray && list.teachSubjectsTxtArray.length > 0" title="任教学科" :value="teachSubjectsTxt" />
      <van-cell v-if="list.otherTeachSubject" title="其他任教学科名称" :value="list.otherTeachSubject" />
      <van-cell v-if="list.b63" title="本县（市、区、旗）登记在册的校外辅导员人数" :value="list.b63" />
      <van-cell v-if="list.b7" title="本县（市、区、旗）未建立少先队组织的中小学校数量" :value="list.b7" />
      <van-cell v-if="list.b8" title="本县（市、区、旗）未建立学校少工委的中小学校数量" :value="list.b8" />

      <van-cell v-if="list.qsngNum" title="由本级少工委直管的建有少先队组织的青少年宫数量" :value="list.qsngNum" />
      <van-cell v-if="list.jljdsgwNum" title="本县（市、区、旗）建立的街道少工委数量" :value="list.jljdsgwNum" />
      <van-cell v-if="list.jlxzsgwNum" title="本县（市、区、旗）建立的乡镇少工委数量" :value="list.jlxzsgwNum" />
      <van-cell v-if="list.jlsqsgwNum" title="本县（市、区、旗）建立的社区少工委数量" :value="list.jlsqsgwNum" />
      <van-cell v-if="list.jlcsgwNum" title="本县（市、区、旗）建立的村少工委数量" :value="list.jlcsgwNum" />

    </van-cell-group>
  </div>
</template>

<script setup>
  import { format } from "@/common/js/utils";
  import { defineProps, computed } from 'vue';
  
  // 直接使用 props，不需要定义在 setup 的返回对象中
  const props = defineProps({
    list: Object,
    type: Number,
  });
  const teachSubjectsTxt = computed(() => {
    return props.list.teachSubjectsTxtArray.length > 0 
        ? props.list.teachSubjectsTxtArray.join(", ") 
        : "请选择";
  });
  console.log("form8---EditList", props.list);
</script>

<style lang="less" scoped>
@import "@/common/style/mixin";
.u_sh li {
  display: list-item;
  height: 1.5rem;
}
.u_sh .fl {
  width: 90%;
}
.reason {
  font-size: 0.397rem;
  line-height: 1.4;
  color: #fd3535;
  vertical-align: middle;
  margin: 0.4rem;
}
</style>
